import React, { useEffect, useState } from 'react'
import { ErrorMessage, Formik } from 'formik'
import Swal from "sweetalert2"
import { useNavigate } from 'react-router-dom'
import * as emailTemplateService from '../../../services/email.template';
import Breadcrums from '../../../common/breadcrumbs';
import CustomCkeditor from '../../../common/customeditor';
import { EMAIL_TEMPLATE_DEFAULT_SHORT_CODES, EMAIL_TEMPLATE_TYPES, SWAL_SETTINGS } from '../../../../../utils/Constants';
import { copyText, globalLoader, handleServerValidations } from '../../../../../utils/commonfunction';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom'
import { CheckPicker, CustomProvider, Tooltip, Whisper } from 'rsuite';

const CATEGORY_OPTIONS = [
    { label: "All", value: "all" },
    { label: "Basic User", value: "basic_user" },
    { label: "Parent", value: "parent" },
    { label: "Player", value: "player" },
    { label: "Club Admin", value: "clubadmin" },
    { label: "Team Manager", value: "team_manager" },
    { label: "Admin", value: "admin" },
];

const EmailTempAdd = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [submitted, setSubmitted] = useState(false);
    const breadcrumbs = [{ title: "Dashboard", url: "/dashboard" }, { title: "Automatic Email ", url: "/admin/cms/default-email-template/list/1" }, { title: "Add", url: "" },];
    const queryParams = new URLSearchParams(location.search);
    const devParam = queryParams.get('dev');
    const showAddButton = devParam === 'true';

    const [defaultLayout, setDefaultLayout] = useState("");
    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
        if (devParam === 'true' || devParam === true) {
            emailTemplateService.Layout().then(response => {
                if (response && response.success) {
                    setDefaultLayout(response.data.layout.replace("{{MESSAGE_BODY}}", "<p>Enter your content here...</p>"));
                }
                setDataLoaded(true);
            }).catch(error => {
                console.log("Error fetching layout:", error);
                setDataLoaded(true);
            });
        }
        else {
            navigate('/admin/cms/default-email-template/list/1?dev=true');
        }
    }, [showAddButton, devParam]);

    const validationSchema = Yup.object().shape({
        title: Yup.string().required('Title is required').test('no-spaces', 'Title is required', (value) => value.trim()),
        slug: Yup.string().required("Slug is required").test('no-spaces', 'Slug is required', (value) => value.trim()),
        subject: Yup.string().required("Subject is required").test('no-spaces', 'Subject is required', (value) => value.trim()),
        richtext: Yup.string().required("Description is required").test('no-spaces', 'Description is required', (value) => value.trim()),
    });

    const handleClick = (text) => {
        copyText(text);
        Swal.fire({
            icon: 'success',
            text: 'Copied',
            ...SWAL_SETTINGS,
        })
    };
    const addOption = (currentValue, setFieldValue) => {
        setFieldValue("options", [...currentValue, ""]);
    };
    const removeOption = (currentValue, index, setFieldValue) => {
        let options = [...currentValue];
        options.splice(index, 1);
        setFieldValue("options", options);
    };
    const stripLayout = (html) => {
        if (!html) return "";
        const match = html.match(/<!-- CONTENT_START -->([\s\S]*?)<!-- CONTENT_END -->/);
        let extracted = html;
        if (match) {
            extracted = match[1].trim();
        } else if (html.includes('<!DOCTYPE html>')) {
            // Fallback for older layouts
            const bodyMatch = html.match(/<td style="padding:[^;]*; color:#333333;">([\s\S]*?)<\/td>/i);
            if (bodyMatch) extracted = bodyMatch[1].trim();
        }

        /** If the extracted content still contains a <tr><td> wrapper (legacy), strip it to avoid nesting */
        if (extracted.toLowerCase().startsWith("<tr>") || extracted.toLowerCase().startsWith("<tr")) {
            const innerMatch = extracted.match(/<td[^>]*>([\s\S]*?)<\/td>/i);
            if (innerMatch) extracted = innerMatch[1].trim();
        }

        return extracted;
    };

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <Formik
                enableReinitialize
                initialValues={{
                    title: "",
                    slug: "",
                    subject: "",
                    richtext: defaultLayout,
                    options: EMAIL_TEMPLATE_DEFAULT_SHORT_CODES,
                    category: [],
                }}
                validateOnBlur={false}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    globalLoader(true);
                    setSubmitted(true)
                    let formData = new FormData();
                    formData.append('title', values.title);
                    formData.append('type', EMAIL_TEMPLATE_TYPES.DEFAULT);
                    formData.append('subject', values.subject);
                    formData.append('description', stripLayout(values.richtext));
                    formData.append('slug', values.slug);
                    formData.append('options', JSON.stringify(values.options));
                    formData.append('category', JSON.stringify(values.category || []));
                    emailTemplateService.Add(formData).then(response => {
                        setSubmitting(false);
                        if (response.success) {
                            Swal.fire({
                                icon: 'success',
                                text: response.message,
                                ...SWAL_SETTINGS
                            })
                            globalLoader(false);
                            setTimeout(() => {
                                resetForm({ values: '' });
                                navigate(`/admin/cms/default-email-template/list/1`)
                            }, 2000);
                        } else {
                            Swal.fire({
                                icon: 'error',
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS
                            })
                            globalLoader(false);
                            setSubmitted(false)
                        }
                    }).catch(error => {
                        console.log("error ====> ", error);
                    })
                }}
            >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,

            }) => (
                <form onSubmit={handleSubmit}>
                    <div className="row row-sm">
                        <div className="col-lg-12 col-md-12 animation_fade">
                            <div className="card custom-card">
                                <div className="card-body">
                                    <div>
                                        <h6 className="main-content-label mb-3">Add Automatic Email </h6>
                                    </div>
                                    <div className="row row-sm">
                                        <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='title' className='text-left d-flex'>Title:<span className="requirestar">*</span> </label>
                                            <input 
                                            name='title' 
                                            id='title' 
                                            type='text' 
                                            placeholder='Enter the title'
                                            onChange={handleChange} 
                                            onBlur={handleBlur} 
                                            value={values.title} 
                                            className='form-control' 
                                            />
                                            <span className='text-danger d-flex text-left'><ErrorMessage name={"title"} /></span>
                                        </div>
                                        <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='slug' className='text-left d-flex'>Slug:<span className="requirestar">*</span> </label>
                                            <input 
                                            name='slug' 
                                            type='text' 
                                            id="slug" 
                                            placeholder='Enter the slug'
                                            onChange={handleChange} 
                                            onBlur={handleBlur} 
                                            value={values.slug} 
                                            className='form-control' 
                                            />
                                            <span className='text-danger d-flex text-left'><ErrorMessage name={"slug"} /></span>
                                        </div>
                                        <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='subject' className='text-left d-flex'>Subject:<span className="requirestar">*</span></label>
                                            <input 
                                            name='subject' 
                                            type='text' 
                                            id="subject" 
                                            placeholder='Enter the subject'
                                            onChange={handleChange} 
                                            onBlur={handleBlur} 
                                            value={values.subject} 
                                            className='form-control' 
                                            />
                                            <span className='text-danger d-flex text-left'><ErrorMessage name={"subject"} /></span>
                                        </div>
                                        <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='category' className='text-left d-flex'>Category:</label>
                                            <CustomProvider>
                                                <CheckPicker
                                                    data={CATEGORY_OPTIONS}
                                                    value={values.category || []}
                                                    onChange={(val) => setFieldValue('category', val)}
                                                    placeholder="Select Categories"
                                                    style={{ width: "100%" }}
                                                    cleanable={true}
                                                    searchable={false}
                                                />
                                            </CustomProvider>
                                        </div>

                                        {showAddButton && (
                                            <>
                                                <div className='col-12'>
                                                    <label htmlFor={"option" + (values?.options?.length - 1)} className='text-left d-flex'>Dynamic Options:
                                                        <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Short Codes to add User Personalized Details such as Name and Email</Tooltip>}>
                                                            <span className='field-more-info mt-1 ms-1 cp'>?</span>
                                                        </Whisper></label>
                                                </div>
                                                <div className="col-lg-12 mb-2">
                                                    {values?.options && values?.options.filter((item) => item !== "").map((item, index) => (
                                                        <span onClick={() => handleClick('{' + item + '}')} key={index} className="badge badge-dark my-2 me-2 cp">{'{' + item + '}'}</span>
                                                    ))}
                                                    <div className="d-flex flex-wrap">
                                                        {values?.options && values?.options.map((item, index) => (
                                                            <div className="mb-3 d-flex align-items-center me-4" key={index}>
                                                                <input name={"options[" + index + "]"} value={item} onChange={handleChange} onBlur={handleBlur} type="text" style={{ width: "150px" }} className="form-control input-sm" id={"option" + (index)} placeholder="New dynamic option" autoFocus={true} />
                                                                {
                                                                    values?.options?.length > 1 ?
                                                                        <button className='btn btn-main-danger bg-secondary text-white btn-sm py-0 px-1 rounded-circle ms-2' type='button' onClick={() => removeOption(values?.options, index, setFieldValue)}><i className="ri-close-large-line"></i></button>
                                                                        : null
                                                                }
                                                                {
                                                                    index === values?.options?.length - 1 ?
                                                                        <button className='btn btn-main-primary signbtn btn-sm py-0 px-1 rounded-circle ms-2' type='button' onClick={() => addOption(values?.options, setFieldValue)}><i className="ri-add-large-line"></i></button>
                                                                        : null
                                                                }
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        <div className='col-lg-12 text-center form-group'>
                                            <label htmlFor='subject' className='text-left d-flex'>Description:<span className="requirestar">*</span></label>
                                            {dataLoaded && (
                                                <CustomCkeditor
                                                    fieldname={"richtext"}
                                                    setFieldValue={setFieldValue}
                                                    value={values.richtext}
                                                    setFieldTouched={setFieldTouched}
                                                />
                                            )}
                                            <span className='text-danger d-flex text-left'>{errors.richtext && touched.richtext && errors.richtext}</span>
                                        </div>
                                        <div className="">
                                            <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={submitted ? true : null}>
                                                <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                Submit
                                            </button>
                                            <button className="btn ripple btn-secondary" type='button' disabled={submitted ? true : null} onClick={() => navigate(-1)}>
                                                <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
            </Formik>
        </>
    )
}

export default EmailTempAdd